
export const customStyles = {
    container: (provided) => ({
        ...provided,
        background: "transparent",
        backgroundColor: "transparent",
    }),
    control: (provided, state) => ({
        ...provided,
        minHeight: 44,
        height: "auto",
        backgroundColor: "var(--wlj-glass-surface, rgba(255, 255, 255, 0.14))",
        background: "var(--wlj-glass-sheen, linear-gradient(155deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.04) 42%, transparent 74%)), var(--wlj-glass-surface, rgba(255, 255, 255, 0.14))",
        color: "var(--label)",
        borderRadius: 4,
        border: "1px solid var(--wlj-field-border, var(--wlj-glass-edge, rgba(255, 255, 255, 0.4)))",
        borderColor: state.isFocused
            ? "var(--wlj-primary, var(--buttonBase, #00419f))"
            : "var(--wlj-field-border, var(--wlj-glass-edge, rgba(255, 255, 255, 0.4)))",
        boxShadow: state.isFocused
            ? "var(--wlj-focus-ring, 0 0 0 3px rgba(0, 65, 159, 0.12))"
            : "var(--wlj-glass-surface-shadow, var(--wlj-shadow))",
        cursor: "pointer",
        transition: "border-color 200ms ease, box-shadow 200ms ease, background-color 200ms ease",
        backdropFilter: "var(--wlj-glass-surface-blur, saturate(150%) blur(20px))",
        WebkitBackdropFilter: "var(--wlj-glass-surface-blur, saturate(150%) blur(20px))",
        "&:hover": {
            borderColor: "var(--buttonBase, #00419f)",
            backgroundColor: "var(--wlj-glass-surface, rgba(255, 255, 255, 0.14))",
            background: "var(--wlj-glass-sheen), var(--wlj-glass-surface, rgba(255, 255, 255, 0.14))",
        },
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: "2px 12px",
        minWidth: 0,
        overflow: "hidden",
        background: "transparent",
        backgroundColor: "transparent",
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        paddingRight: 6,
        background: "transparent",
        backgroundColor: "transparent",
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: "var(--wlj-icon, var(--wlj-text-secondary, #64748b))",
        fill: "currentColor",
        padding: 6,
        opacity: 1,
        "&:hover": {
            color: "var(--wlj-primary, var(--buttonBase, #2563eb))",
            fill: "currentColor",
        },
        svg: {
            fill: "currentColor",
            color: "inherit",
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: "var(--wlj-icon, var(--wlj-text-secondary, #64748b))",
        fill: "currentColor",
        padding: 6,
        opacity: 1,
        "&:hover": {
            color: "var(--wlj-primary, var(--buttonBase, #2563eb))",
            fill: "currentColor",
        },
        svg: {
            fill: "currentColor",
            color: "inherit",
        },
    }),
    indicatorSeparator: () => ({
        display: "none",
    }),
    singleValue: (provided) => ({
        ...provided,
        color: "var(--mainTextColor, #101828)",
        fontSize: 13,
        fontWeight: 500,
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        zIndex: 2,
        background: "transparent",
        backgroundColor: "transparent",
        boxShadow: "none",
    }),
    inputContainer: (provided) => ({
        ...provided,
        margin: 0,
        padding: 0,
        background: "transparent",
        backgroundColor: "transparent",
    }),
    placeholder: (provided) => ({
        ...provided,
        color: "var(--wlj-modal-placeholder, var(--wlj-text-secondary, #475569))",
        fontSize: 13,
        margin: 0,
        opacity: 1,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "calc(100% - 8px)",
    }),
    input: (provided, state) => ({
        ...provided,
        color: "var(--mainTextColor, #101828)",
        fontSize: 13,
        margin: 0,
        padding: 0,
        background: "transparent",
        backgroundColor: "transparent",
        border: "none",
        boxShadow: "none",
        minHeight: 0,
        width: state.isHidden ? 0 : "auto",
        minWidth: state.isHidden ? 0 : 2,
        opacity: state.isHidden ? 0 : 1,
    }),
    option: (provided, state) => ({
        ...provided,
        borderRadius: 4,
        margin: "2px 4px",
        padding: "10px 12px",
        minHeight: 44,
        fontSize: 14,
        lineHeight: 1.35,
        whiteSpace: "normal",
        fontWeight: state.isSelected ? 600 : 500,
        cursor: "pointer",
        backgroundColor: "transparent",
        background: state.isSelected
            ? "var(--wlj-active-bg)"
            : state.isFocused
                ? "var(--wlj-hover-bg)"
                : "transparent",
        color: state.isSelected || state.isFocused
            ? "var(--buttonBase, #00419f)"
            : "var(--wlj-nav-ink, #444444)",
        "&:hover": {
            background: "var(--wlj-active-bg)",
            color: "var(--buttonBase, #00419f)",
        },
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: "var(--wlj-glass-dropdown, rgba(232, 239, 248, 0.92))",
        background: "var(--wlj-glass-sheen, linear-gradient(155deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.04) 42%, transparent 74%)), var(--wlj-glass-dropdown, rgba(232, 239, 248, 0.92))",
        backdropFilter: "var(--wlj-glass-dropdown-blur, saturate(180%) blur(28px))",
        WebkitBackdropFilter: "var(--wlj-glass-dropdown-blur, saturate(180%) blur(28px))",
        border: "1px solid var(--wlj-glass-edge, rgba(255, 255, 255, 0.4))",
        borderRadius: 4,
        boxShadow: "var(--wlj-glass-shadow, var(--wlj-shadow))",
        overflow: "hidden",
        marginTop: 8,
        marginBottom: 8,
        padding: 6,
    }),
    menuList: (provided) => {
        const cap = 280;
        return {
            ...provided,
            backgroundColor: "transparent",
            maxHeight: cap,
            overflowY: "auto",
            padding: 6,
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "thin",
            scrollbarColor: "var(--wlj-primary, #00419f) transparent",
        };
    },
    menuPortal: (provided) => ({
        ...provided,
        pointerEvents: "auto",
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: "var(--wlj-active-bg, #e8eef7)",
        borderRadius: 4,
        display: "flex",
        alignItems: "center",
        margin: "2px",
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: "var(--buttonBase, #00419f)",
        fontSize: 12,
        fontWeight: 500,
        paddingTop: 0,
        paddingBottom: 0,
        lineHeight: 1.25,
        display: "flex",
        alignItems: "center",
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: "var(--buttonBase, #00419f)",
        display: "flex",
        alignItems: "center",
        alignSelf: "center",
        paddingTop: 0,
        paddingBottom: 0,
        marginTop: 0,
        marginBottom: 0,
        ":hover": {
            backgroundColor: "transparent",
            color: "var(--wlj-danger, #e11d48)",
        },
    }),
};

export const wljSelectPortalProps = {
    classNamePrefix: "wlj-select",
    menuPosition: "fixed",
    get menuPortalTarget() {
        return typeof document !== "undefined" ? document.body : null;
    },
};

export const privacySelectStyles = {
    ...customStyles,
    control: (provided, state) => ({
        ...customStyles.control(provided, state),
        minHeight: 36,
        height: 36,
        minWidth: 158,
        borderRadius: 4,
        backgroundColor: "var(--wlj-modal-field, rgba(255, 255, 255, 0.08))",
        background: "var(--wlj-glass-sheen, linear-gradient(155deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.04) 42%, transparent 74%)), var(--wlj-modal-field, rgba(255, 255, 255, 0.08))",
        backdropFilter: "none",
        WebkitBackdropFilter: "none",
        border: "1px solid var(--wlj-field-border, var(--wlj-glass-edge, rgba(255, 255, 255, 0.4)))",
        borderColor: state.isFocused
            ? "var(--wlj-primary, var(--buttonBase, #00419f))"
            : "var(--wlj-field-border, var(--wlj-glass-edge, rgba(255, 255, 255, 0.4)))",
        boxShadow: state.isFocused
            ? "var(--wlj-focus-ring, 0 0 0 3px rgba(0, 65, 159, 0.12))"
            : "var(--wlj-glass-surface-shadow, var(--wlj-shadow))",
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: "0 8px",
        overflow: "visible",
        height: 34,
        display: "flex",
        alignItems: "center",
    }),
    singleValue: (provided) => ({
        ...customStyles.singleValue(provided),
        display: "flex",
        alignItems: "center",
        maxWidth: "none",
        overflow: "visible",
        position: "static",
        transform: "none",
        margin: 0,
    }),
    input: (provided) => ({
        ...customStyles.input(provided),
        opacity: 0,
        width: 0,
        minWidth: 0,
        margin: 0,
        padding: 0,
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        height: 36,
        paddingRight: 2,
    }),
    dropdownIndicator: (provided) => ({
        ...customStyles.dropdownIndicator(provided),
        padding: 4,
    }),
};
